import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from 'axios';
import { review_appConnect } from "../../sample-data";

const initialState = {
  data: [],
  isLoading: true,
  error: "",
};

export const url = `https://jsonplaceholder.typicode.com/posts/1`;

export const fetchAppConnect = createAsyncThunk(
  "AppConnect/fetchAppConnect",
  async (thunkApi, { rejectWithValue }) => {    
    await new Promise(resolve => setTimeout(resolve, 200));
    return review_appConnect;
    try {
      const response = await axios.get(url, {
        validateStatus: status => status >= 200 && status < 300,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(`Error: ${err.message}`);
    }
  }
);

export const sliceAppConnect = createSlice({
  name: "AppConnect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppConnect.pending, (state) => {
        state.isLoading = true;
        state.error = ""; // Reset error on pending state
      })
      .addCase(fetchAppConnect.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = ""; // Reset error on successful fetch
      })
      .addCase(fetchAppConnect.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        console.log(state.error);
      });
  },
});

export const selectAppConnectData = (state) => state.AppConnect.data;
export const selectIsLoading = (state) => state.AppConnect.isLoading;
export const selectError = (state) => state.AppConnect.error;

// Access data directly from state using getter functions within your components
// for example:
// const data = useSelector(state => state.AppConnect.data);
/*
const { data, isLoading, error } = useSelector(state => ({
  data: state.AppConnect.data,
  isLoading: state.AppConnect.isLoading,
  error: state.AppConnect.error,
}));
*/
export default sliceAppConnect.reducer; // Export the reducer
